import { Loader2Icon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { intranetChatActionLabel } from '@/products/intranet/features/intranet/intranet-chat-action';
import { useIntranetChatAction } from '@/products/intranet/features/intranet/use-intranet-chat-action';

type ColleagueChatButtonProps = {
  userId: string;
  reachesViaTeams: boolean;
  /** Hide when the card is the signed-in person. */
  hidden?: boolean;
  className?: string;
  variant?: 'default' | 'outline' | 'secondary';
  size?: 'default' | 'sm';
};

/** Opens Teams or the portal chat for one colleague. */
export function ColleagueChatButton({
  userId,
  reachesViaTeams,
  hidden = false,
  className,
  variant = 'outline',
  size = 'sm',
}: ColleagueChatButtonProps) {
  const { startChat, isPending } = useIntranetChatAction();
  if (hidden) {
    return null;
  }
  const label = intranetChatActionLabel(reachesViaTeams);

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      className={className}
      disabled={isPending}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        void startChat(userId);
      }}
    >
      {isPending ? <Loader2Icon className="size-4 animate-spin" aria-hidden /> : null}
      {label}
    </Button>
  );
}
